import { Circles } from "react-loader-spinner";

import "./styles.scss";

function FullPageSpinner({ message }) {
    return (
        <div className="d-flex align-items-center justify-content-center loader-overlay">
            <div className="d-flex flex-column align-items-center gap-3">
                <Circles
                    height="80"
                    width="80"
                    color="#13294B"
                    ariaLabel="bars-loading"
                    visible={true}
                />
                <span>{message}</span>
            </div>
        </div>
    );
}

export default FullPageSpinner;
